/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The three states `UI-Design-Spec.md#s11` colours a data-health cell by.
 *
 * > "Market-data health is a matrix, pair × timeframe, one cell per series, coloured by
 * > staleness only: `--bg-inset` fresh, `--attn` ageing, `--loss` stale."
 *
 * Named here rather than in the API because the boundary between them is the staleness
 * factor the engine already trades on, and **the server decides** (H9-shaped reasoning:
 * a client that computed its own thresholds would eventually disagree with the gate that
 * actually stops trading, and the disagreement would be invisible on both sides).
 */
export enum Freshness {
    FRESH = 'fresh',
    AGEING = 'ageing',
    STALE = 'stale',
}
